<template>
  <v-container fluid
               v-if="contact">
    <PageTitle icon="fal fa-fw fa-fax">
      Edit Fax Contact
    </PageTitle>

    <v-form @submit.prevent="submit"
            :disabled="contact.is_unsubscribed"
            autocomplete="off">
      <v-card>
        <v-card-text>
          <fax-contact-form :contact="contact"
                            :form="form">
          </fax-contact-form>
        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary">
            Update
          </v-btn>
          <v-btn @click.prevent="$router.back()">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import faxService from '../../../services/faxService';
import FaxContactForm from './components/FaxContactForm';
import {Form} from 'vform';
import DOMPurify from 'dompurify';
import PageTitle from '../../../components/PageTitle.vue';

export default {
  components: {PageTitle, FaxContactForm},
  data() {
    return {
      busy: false,
      contact: null,
      form: new Form(faxService.getFormFields())
    }
  },
  computed: {
    contactID() {
      return parseInt(this.$route.params.contactID);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      faxService.getContact(this.contactID)
        .then(data => {
          faxService.populateForm(this.form, data);
          this.contact = data;
          return true;
        })
        .catch(err => {
          console.log(err);
          this.$toast.error('Contact not found');
          this.$router.replace({name: `${this.$root.routePrefix}.fax_contacts.index`});
        })
    },
    submit() {
      if (this.contact.is_unsubscribed) {
        this.$toast.warning('You cannot edit an unsubscribed contact.');
        return;
      }
      if (this.form.busy) {
        return;
      }
      faxService.updateContact(this.contactID, this.form)
        .then(data => {
          this.$router.push({name: `${this.$root.routePrefix}.fax_contacts.index`});
        })
        .catch(err => {
          this.$toast.error(DOMPurify.sanitize(err.message));
        })
    }
  }
}
</script>
